import { render, staticRenderFns } from "./Microsite.vue?vue&type=template&id=7f1deb7c&scoped=true&"
import script from "./Microsite.vue?vue&type=script&lang=ts&"
export * from "./Microsite.vue?vue&type=script&lang=ts&"
import style0 from "./Microsite.vue?vue&type=style&index=0&id=7f1deb7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1deb7c",
  null
  
)

export default component.exports